import {GlobalVariables} from "../GlobalVariables";
import {ScrollTrigger} from "../LibrariesImport";
export default class SubNav {
    static init() {

        this.subnav = document.querySelector('.main-subnav');

        if( this.subnav ){

            this.banner = document.querySelector('.banner');
            ScrollTrigger.create({
                trigger: this.banner,
                start: "bottom top",
                end: 9999,
                toggleClass: {
                    targets: this.subnav,
                    className: 'is-visible'
                }
            });

            this.open = this.subnav.querySelector('.open');
            this.open.addEventListener("click", () => {
                this.subnav.classList.add('is-opened');
            });

            this.close = this.subnav.querySelector('.close');
            this.close.addEventListener("click", () => {
                this.subnav.classList.remove('is-opened');
            });

            this.navs = this.subnav.querySelectorAll('.inner li span');
            this.navs.forEach( (nav) => {
                const anchor = nav.dataset.anchor;
                nav.addEventListener('click', () => {
                    document.querySelector(anchor).scrollIntoView({
                        behavior: 'smooth'
                    });
                });
            });

        }

    }

}